import React from "react";
import {AuthorizationService} from "../../../service/v1/authorization";
import PopDetail from "../../popdetail";
import Wait from "../../wait";

export default class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            username: ''
        }
        this.handleChanges = this.handleChanges.bind(this)
        this.submit = this.submit.bind(this)
    }

    componentDidMount() {
        // Try to get username from sessionStorage or decoded token
        const username = sessionStorage.getItem('username');
        const decoded = sessionStorage.getItem('decoded');
        let usernameFromToken = '';
        
        if (decoded) {
            try {
                const decodedData = JSON.parse(decoded);
                usernameFromToken = decodedData.username;
            } catch (e) {
                console.log('Error parsing decoded token:', e);
            }
        }

        this.setState({
            username: username || usernameFromToken || ''
        });
    }

    handleChanges(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    submit() {
        const {currentPassword, newPassword, confirmPassword} = this.state;
        
        if (!currentPassword || !newPassword || !confirmPassword) {
            alert('All fields are required');
            return;
        }

        if (newPassword !== confirmPassword) {
            alert('New password and confirm password do not match');
            return;
        }

        try {
            Wait.show('Changing password...');
            AuthorizationService.changePassword({
                current_password: currentPassword,
                new_password: newPassword
            }).then(r => {
                Wait.dismiss();
                alert('Password changed successfully');
                PopDetail.dismiss();
            }).catch(error => {
                Wait.dismiss();
                const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Failed to change password';
                alert(errorMessage);
                console.log('Password change error:', error.response?.data);
            });
        } catch (e) {
            Wait.dismiss();
            alert('An error occurred while changing password');
            console.log(e);
        }
    }

    render() {
        return (
            <div className={'row'}>
                <div className={'col col-sm-12'} style={{padding: 0}}>
                    <table style={{width: '94%', margin: '2%'}}>
                        <tbody>
                            <tr>
                                <td className={'label'}>Username</td>
                            </tr>
                            <tr>
                                <td>
                                    <input 
                                        type={'text'} 
                                        value={this.state.username} 
                                        style={{width: '100%', padding: '8px'}}
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className={'label'}>Current Password</td>
                            </tr>
                            <tr>
                                <td>
                                    <input 
                                        type={'password'} 
                                        name={'currentPassword'} 
                                        style={{width: '100%', padding: '8px'}}
                                        onChange={this.handleChanges}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className={'label'}>New Password</td>
                            </tr>
                            <tr>
                                <td>
                                    <input 
                                        type={'password'} 
                                        name={'newPassword'} 
                                        style={{width: '100%', padding: '8px'}}
                                        onChange={this.handleChanges}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className={'label'}>Confirm New Password</td>
                            </tr>
                            <tr>
                                <td>
                                    <input 
                                        type={'password'} 
                                        name={'confirmPassword'} 
                                        style={{width: '100%', padding: '8px'}}
                                        onChange={this.handleChanges}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{textAlign: 'center', width: '100%', float: 'left', marginTop: '20px'}}>
                        <button className={'btn submit'} onClick={this.submit}>
                            <span className={'fa fa-save'}/>Change Password
                        </button>
                        <button className={'btn error'} onClick={() => PopDetail.dismiss()} style={{marginLeft: '8px'}}>
                            <span className={'fa fa-times'}/>Cancel
                        </button>
                    </div>
                </div>
            </div>
        )
    }
} 